
import { defineComponent } from 'vue'

export default defineComponent({
    name: "ss-card",
    props: {
        remove: { type: String, default: undefined },
        title: { type: String, default: undefined },
        icon: { type: String, default: undefined }
    },
    data() {
        return {
            hasRemove: this.$attrs['onRemove'] != undefined
        }
    },
    methods: {
        removeCard() {
            this.$emit('remove')
        }
    }
})
